import { render } from "./DateInputField.vue?vue&type=template&id=55393348&scoped=true"
import script from "./DateInputField.vue?vue&type=script&lang=js"
export * from "./DateInputField.vue?vue&type=script&lang=js"

import "./DateInputField.vue?vue&type=style&index=0&id=55393348&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55393348"]])

export default __exports__